import vision from '../../components/vision/vision'
import glory from '../../components/glory/glory'
import qualifications from '../../components/qualifications/qualifications'
import contact from '../../components/contactUs/contactUs'
import industryPartners from '../../components/industryPartners/industryPartners'
import responsibility from '../../components/responsibility/responsibility'
export default ({
    data() {
        return {
            currentMenu: '/about/vision',
        }
    },
    components: { vision, glory, qualifications, contact,industryPartners, responsibility },
    created() {
        var route = this.$route.path
        if(route === '/about/vision') {
            this.currentMenu = '/about/vision'
        } else if (route === '/about/glory') {
            this.currentMenu = '2-1'
        } else if (route === '/about/responsibility') {
            this.currentMenu = '/about/responsibility'
        } else if (route === '/about/contact') {
            this.currentMenu = '/about/contact'
        } else if (route === '/about/partners') {
            this.currentMenu = '/about/partners'
        }
    },
    watch:{
        //监听路由变化
        $route(to,from){
            var route = to.path
            this.currentMenu = route
            var index = this.$route.query.index || ''
            if(route === '/about/vision') {
                this.currentMenu = '/about/vision'
            } else if (route === '/about/glory') {
                if(index){
                    this.currentMenu = index
                }else{
                    this.currentMenu = '2-1'
                }
            } else if (route === '/about/responsibility') {
                this.currentMenu = '/about/responsibility'
            } else if (route === '/about/contact') {
                this.currentMenu = '/about/contact'
            } else if (route === '/about/partners') {
                this.currentMenu = '/about/partners'
            }
        }
    },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
            if(page == '/about/vision' && route != '/about/vision'){
                this.$router.push({path:'/about/vision'})
            }else if(page.slice(0,1) == '2' && route != '/about/glory') {
                this.$router.push({path:'/about/glory',query: { index: this.currentMenu}})
            } else if (page == '/about/responsibility' && route != '/about/responsibility') {
                this.$router.push({path:'/about/responsibility'})
            } else if (page == '/about/contact' && route != '/about/contact') {
                this.$router.push('/about/contact')
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/about/about.vue.js